/**
 * Gérer l'intéractivité du bouton filtre.
 *
 * @export
 * @class Filters
 */
export default class Filters {
    filtersBtn;
    filtersGrille;
    /**
     * Créer une instance de Filters.
     *
     * @param {HTMLButtonElement} filtersBtn
     * @memberof Filters
     */
    constructor(filtersBtn) {
        this.filtersBtn = filtersBtn;
        this.filtersGrille = document.getElementById('filters-grille');
        this.ajouterListeners();
    }
    /**
     * Ajouter les listeners.
     *
     * @private
     * @memberof Filters
     */
    ajouterListeners() {
        this.filtersBtn.addEventListener('click', () => { this.handleClick(); });
    }
    /**
     * Gérer un click sur le bouton filtre.
     *
     * @private
     * @memberof Filters
     */
    handleClick() {
        this.filtersGrille.classList.toggle('parts__filters-grille--filters-hidden');
    }
}
